import { IotaClient } from '@iota/iota-sdk/client';
import type { WalletAccount } from '@wallet-standard/core';
import BigNumber from 'bignumber.js';

import { Env, IOTA_DEFAULT_DIVIDER } from 'modules/common';

import { createStakeTransaction } from './createStakeTransaction';

interface IStakeParams {
  walletAccount: WalletAccount;
  client: IotaClient;
  amount: BigNumber;
  env: Env;
}

export async function getStakeGasEstimation({
  walletAccount,
  client,
  amount,
  env,
}: IStakeParams): Promise<{ estimatedGas: BigNumber }> {
  const { transaction } = createStakeTransaction(env, walletAccount, amount);

  transaction.setSender(walletAccount.address);

  await transaction.build({ client });

  const { budget } = transaction.getData().gasData;

  if (!budget) {
    throw new Error('Budget not defined.');
  }

  const estimatedGas = new BigNumber(budget).div(IOTA_DEFAULT_DIVIDER);

  return { estimatedGas };
}
